import { Waypoint } from 'react-waypoint';

import { Separator, Text } from '@change/ds-core-ui/next';

import {
	useMarkModuleAsLoaded,
	useRecommendations as useRecommendationsContext,
} from 'src/app/pages/starterDashboardV2/shared/contexts';
import type { WaypointCallbackArgs } from 'src/app/shared/components/layout/lazy';

import { RecommendationsCarousel } from './components/RecommendationsCarousel';
import { ShareUrlReskin } from './components/ShareUrl/index_new';
import { useRecommendations } from './hooks/useRecommendations';

import type { Props } from './index';

export function RecommendationsVariant2Reskin({ viewContext }: Omit<Props, 'slug'>): React.JSX.Element | null {
	const {
		data: { shareRecommendationsLoading, shouldDisplayShareRecommendations, shareRecommendations },
	} = useRecommendationsContext();

	const { actions } = useRecommendations();

	useMarkModuleAsLoaded('Recommendations', !shareRecommendationsLoading && shouldDisplayShareRecommendations);

	if (!shouldDisplayShareRecommendations) {
		return null;
	}

	const firstRedditRec = shareRecommendations.reddit.at(0);
	const firstFacebookRec = shareRecommendations.facebook.at(0);

	return (
		<section aria-labelledby="recommendations-title" className="bg-background-base px-4 py-8 pr-0 md:p-12 md:pr-0">
			<Waypoint
				onEnter={(waypointCallbackArgs: WaypointCallbackArgs) => {
					actions.trackView(
						waypointCallbackArgs,
						firstFacebookRec?.metadata.source,
						firstRedditRec?.metadata.source,
						viewContext,
					);
				}}
			/>
			<div className="flex flex-col gap-6">
				<div className="flex flex-col gap-5 pr-4 md:pr-12">
					<div className="flex flex-col gap-3">
						<Text as="h3" className="text-size-heading-small">
							Share in recommended groups
						</Text>
						<Text variant="body">
							{actions.translateHtml('corgi.petition.starter_dashboard.recommendations.description_variant')}&nbsp;
						</Text>
					</div>
					<div className="w-full md:w-auto">
						<ShareUrlReskin viewContext={viewContext} />
					</div>
				</div>
				<div className="pr-4 md:pr-12">
					<Separator className="m-0" />
				</div>
				<RecommendationsCarousel
					loading={shareRecommendationsLoading}
					shareRecommendations={shareRecommendations}
					isReskin
					viewContext={viewContext}
				/>
			</div>
		</section>
	);
}
